import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyle = createUseStyles((theme: CmsWrenchTheme) => {
  const mediaQueryMinScreenMD = `@media (min-width: ${theme.breakpoints.md}px)`;
  const mediaQueryMinScreenLG = `@media (min-width: ${theme.breakpoints.lg}px)`;

  return {
    darkBackground: {
      backgroundColor: theme.brandColors.primary.vine,
      paddingRight: theme.spacing[5],
      paddingLeft: theme.spacing[5],
      paddingTop: theme.spacing[6],
    },

    curiosityConBg: {
      backgroundColor: '#1E2124',
      paddingBottom: theme.spacing[2],
      [mediaQueryMinScreenMD]: {
        paddingBottom: theme.spacing[8],
      },
    },

    buttonBox: {
      display: 'block',
      [mediaQueryMinScreenMD]: {
        display: 'flex',
      },
    },

    headerFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > section': {
        fontSize: theme.type.fontSize.hero2,
        marginTop: theme.spacing[2],
        [mediaQueryMinScreenLG]: {
          fontSize: theme.type.fontSize.hero1,
          minWidth: 500,
        },
      },
      '& > span': {
        letterSpacing: '2px',
      },
    },

    balancedText: {
      textWrap: 'balance',
    },

    subHeaderFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > p': {
        fontSize: theme.type.fontSize.body,
        lineHeight: 1.8,
      },
    },

    resSubHeaderFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > p': {
        fontSize: theme.type.fontSize.body,
        lineHeight: 1.5,
        [mediaQueryMinScreenLG]: {
          fontSize: '18px',
          maxWidth: 520,
          lineHeight: 1.8,
        },
      },
    },

    ctaForm: {
      margin: '0 auto',
      maxWidth: '380px',
    },

    logo: {
      height: 24,
      [mediaQueryMinScreenMD]: {
        height: 44,
      },
    },

    subHeader: {
      maxWidth: 400,
      [mediaQueryMinScreenMD]: {
        maxWidth: 600,
      },
      [mediaQueryMinScreenLG]: {
        maxWidth: 1000,
      },
    },

    bold: {
      fontWeight: 500,
    },

    strangeBox: {
      maxWidth: 550,
    },

    conSection: {
      paddingTop: theme.spacing[4],
      [mediaQueryMinScreenMD]: {
        paddingTop: theme.spacing[8],
      },
    },
    ctaSection: {
      paddingTop: theme.spacing[8],
      paddingBottom: theme.spacing[8],
    },

    ctaWrapper: {
      maxWidth: 548,
    },

    newCTAWrapper: {
      maxWidth: 492,
    },

    headerDesktopPadding: {
      paddingTop: theme.spacing[5],
      [mediaQueryMinScreenMD]: {
        paddingBottom: theme.spacing[7],
        paddingTop: theme.spacing[9],
      },
    },

    videoContainer: {
      marginBottom: 0,
      height: '300px',
      [mediaQueryMinScreenMD]: {
        marginBottom: theme.spacing[8],
        height: 'auto',
      },
    },

    videoBox: {
      height: '300px',
    },

    imagePlacement: {
      width: '100%',
      maxWidth: 604,
      marginBottom: 0,
      [mediaQueryMinScreenMD]: {
        paddingLeft: theme.spacing[4],
      },
      [mediaQueryMinScreenLG]: {
        paddingLeft: 0,
      },
    },

    videoPlacement: {
      width: '100%',
      maxWidth: 604,
      marginBottom: 0,
      [mediaQueryMinScreenMD]: {
        paddingLeft: theme.spacing[4],
      },
      [mediaQueryMinScreenLG]: {
        paddingLeft: 0,
      },
    },

    imageDesktop: {
      display: 'none',
      [mediaQueryMinScreenMD]: {
        display: 'block',
      },
    },

    imageMobile: {
      display: 'block',
      [mediaQueryMinScreenMD]: {
        display: 'none',
      },
    },

    resGripTemplate: {
      gridTemplateRows: '312px',
      [mediaQueryMinScreenMD]: {
        gridTemplateRows: '477px',
      },
    },
  };
});

export default useStyle;
